import { useParams } from "react-router-dom";
import BreadcrumbCentralWarehouse from "../BreadcrumbCentralWarehouse";
import moment from "moment";
import { CircularProgress } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { getDetailWarehouse } from "../../../../services/centralWarehouseApi";
import { useEffect, useState } from "react";
import { TbNotes } from "react-icons/tb";
import ModalNoteAllocation from "./ModalNoteAllocation";

const toIDR = (val) =>
  val?.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });

const DetailAllocation = ({ type }) => {
  const { id } = useParams();

  const [selectedNote, setSelectedNote] = useState(null);

  const {
    mutate: mutateDetail,
    isLoading,
    data: dataDetail,
  } = useMutation({
    mutationFn: getDetailWarehouse,
  });

  useEffect(() => {
    mutateDetail({ id: Number(id), type: type });
  }, [id]);

  return (
    <div className="text-[12px]">
      <BreadcrumbCentralWarehouse />
      <div className="flex gap-4 items-center mb-4">
        <div className="w-full">
          {dataDetail && !isLoading ? (
            <>
              {" "}
              <div className="flex gap-2 items-center">
                <p className="w-1/3">Transaction ID</p>
                <p>: {dataDetail.header.transaction_number}</p>
              </div>
              <div className="flex gap-2 items-center">
                <p className="w-1/3">Allocation Date</p>
                <p>: {moment(dataDetail.header.date).format("DD/MM/YYYY")}</p>
              </div>
              <div className="flex gap-2 items-center">
                <p className="w-1/3">Outlet Destination</p>
                <p>: {dataDetail.header.target}</p>
              </div>
              <div className="flex gap-2 items-center">
                <p className="w-1/3">User</p>
                <p>: {dataDetail.header.created_by}</p>
              </div>
            </>
          ) : isLoading ? (
            <CircularProgress size={20} />
          ) : (
            <p>Terjadi kesalahan dalam mengambil data</p>
          )}
        </div>
        <div className="basis-1/2">
          {dataDetail && !isLoading ? (
            <>
              <div
                className={`border-2 w-full rounded-lg p-2 text-center mb-2 ${
                  dataDetail.header.status === 1
                    ? ""
                    : dataDetail.header.status === 2 ||
                      ((type === 4 || type === 5) &&
                        dataDetail.header.status === 4)
                    ? "border-blue-500 text-blue-500 bg-blue-100"
                    : dataDetail.header.status === 4
                    ? "border bg-gray-100"
                    : "border-red-500 text-red-500 bg-red-100"
                }`}
              >
                {dataDetail.header.status === 1
                  ? "In Progress"
                  : (type === 4 || type === 5) && dataDetail.header.status === 4
                  ? "Good in Transit"
                  : (type === 4 || type === 5) && dataDetail.header.status === 5
                  ? "Rejected by Outlet"
                  : dataDetail.header.status === 2 ||
                    (type < 4 && dataDetail.header.status === 4)
                  ? "Accepted"
                  : "Rejected"}
              </div>
              {dataDetail.header.status > 1 ? (
                <p>
                  {(dataDetail.header.status === 2) |
                  (dataDetail.header.status === 4)
                    ? "Accepted "
                    : "Rejected"}{" "}
                  on: {moment().format("DD MMMM YYYY")}
                </p>
              ) : null}
            </>
          ) : null}
        </div>
      </div>

      <p className="font-bold">Selected Product</p>
      <hr className="my-2" />
      <div className="flex w-full mb-4">
        <div className="w-full">
          <div className="block overflow-x-auto w-full rounded-md">
            <table className="w-full overflow-x-auto rounded-md border-collapse">
              <thead className="bg-blue-500 text-white">
                <th className="py-2 text-center">No</th>
                <th className="px-3 py-2 text-left whitespace-nowrap">
                  Product Name
                </th>
                <th className="px-3 py-2 text-left whitespace-nowrap">Batch</th>
                <th className="px-3 py-2 text-left whitespace-nowrap">
                  Expired Date
                </th>
                <th className="px-3 py-2 text-left whitespace-nowrap">UOM</th>
                <th className="px-3 py-2 text-center whitespace-nowrap">Qty</th>
                <th className="px-3 py-2 text-center whitespace-nowrap">
                  Qty Received
                </th>
                <th className="px-3 py-2 text-center whitespace-nowrap">
                  Qty Back
                </th>
                {type < 3 ? (
                  <th className="px-3 py-2 text-left whitespace-nowrap">HNA</th>
                ) : null}
                {type < 3 ? (
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Diskon
                  </th>
                ) : null}
                {type < 3 ? (
                  <th className="px-3 py-2 text-left whitespace-nowrap">PPN</th>
                ) : null}
                {type < 4 ? (
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Final Price
                  </th>
                ) : null}
                {type < 4 ? (
                  <th className="px-3 py-2 text-left whitespace-nowrap">
                    Total
                  </th>
                ) : null}
                <th className="px-3 py-2 text-left whitespace-nowrap">
                  Reason
                </th>
                <th className="px-3 py-2 text-center whitespace-nowrap">
                  Notes
                </th>
              </thead>
              <tbody>
                {dataDetail && !isLoading && dataDetail.product ? (
                  dataDetail.product.map((item, i) => (
                    <tr key={i}>
                      <td className="px-3 py-2 border text-center">{i + 1}</td>
                      <td className="px-3 py-2 border  text-left">
                        {item.product_name}
                      </td>
                      <td className="px-3 py-2 border  text-left">
                        {item.batch}
                      </td>
                      <td className="px-3 py-2 border text-left">
                        {moment(item.expired_date).format("DD-MM-YYYY")}
                      </td>
                      <td className="px-3 py-2 border text-left">{item.uom}</td>
                      <td className="px-3 py-2 border text-center">
                        {item.quantity}
                      </td>
                      <td className="px-3 py-2 border text-center">
                        {item.quantity_received}
                      </td>
                      <td className="px-3 py-2 border text-center">
                        {item.quantity_back}
                      </td>
                      {type < 3 ? (
                        <td className="px-3 py-2 border text-left">
                          {toIDR(
                            item.pharmacy_net_price
                              ? item.pharmacy_net_price
                              : 0
                          )}
                        </td>
                      ) : null}
                      {type < 3 ? (
                        <td className="px-3 py-2 border text-left">
                          {item.pharmacy_net_price_discount
                            ? item.pharmacy_net_price_discount
                            : 0}
                          %
                        </td>
                      ) : null}
                      {type < 3 ? (
                        <td className="px-3 py-2 border text-left">
                          {item.pharmacy_net_price_ppn_value
                            ? item.pharmacy_net_price_ppn_value * 100
                            : 0}
                          %
                        </td>
                      ) : null}
                      {type < 4 ? (
                        <td className="px-3 py-2 border text-left">
                          {toIDR(item.hna)}
                        </td>
                      ) : null}
                      {type < 4 ? (
                        <td className="px-3 py-2 border text-left">
                          {toIDR(item.total)}
                        </td>
                      ) : null}
                      <td className="px-3 py-2 border text-left">
                        {item.reason}
                      </td>
                      <td className="px-3 py-2 border text-center">
                        <div
                          className="flex justify-center"
                          onClick={() => setSelectedNote(item.notes)}
                        >
                          <TbNotes className="text-[18px] cursor-pointer hover:text-gray-300" />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      className="px-3 py-2 border text-center"
                      colSpan={type < 3 ? 15 : type < 4 ? 12 : 10}
                    >
                      {isLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        "Tidak ada produk"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <ModalNoteAllocation note={selectedNote} setNote={setSelectedNote} />
    </div>
  );
};

export default DetailAllocation;
